import React, { useState } from "react";
import { Target } from "lucide-react";
import HeaderMenu from "../../Navbar/headermenu";
import NavigateLikeFileSystem from "./NavigateLikeFileSystem";
import DocumentJourney from "./DocumentJourney";
import ThreeCategoriesSection from "./ThreeCategoriesSection";
import ProfessionalPowerSection from "./ProfessionalPowerSection";
import CustomFooter from "../../Footer/customFooter";
import { Helmet } from "react-helmet";
export default function () {
  return (
    <div>
      <Helmet>
        <title>Complete Control. Zero Effort. | Simplifyte</title>
      </Helmet>
      <HeaderMenu />
      {/* Tailwind Apply */}
      {/* bg-gradient-to-br from-black via-gray-900 to-gray-800 */}
      <section
        className="relative min-h-screen bg-white overflow-hidden 
             bg-[#010c13] _Main_Class"
      >
        <div className="docs_Tabss flex items-center">
          {/* <div
            className="absolute inset-0 opacity-20"
            style={{
              backgroundImage:
                "radial-gradient(circle, rgba(255, 255, 255, 0.1) 1px, transparent 1px)",
              backgroundSize: "50px 50px",
            }}
          ></div> */}

          {/* <div className="absolute top-20 right-1/4 w-[600px] h-[600px] bg-cyan-500/10 rounded-full blur-[120px]"></div>
          <div className="absolute bottom-20 left-1/4 w-[500px] h-[500px] bg-cyan-400/10 rounded-full blur-[100px]"></div>
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(6,182,212,0.05),transparent_50%)]"></div> */}

          <div className="max-w-7xl mx-auto relative z-10 w-full">
            <div className="text-center DocsHero_mrg">
              {/* <div className="inline-flex items-center gap-2 bg-gradient-to-r from-cyan-500/10 to-cyan-400/10 border-2 border-cyan-500/30
                             text-cyan-400 px-8 py-3 rounded-full mb-12 backdrop-blur-sm shadow-lg ">
                                <Target className="w-5 h-5" />
                                <span className="text-sm tracking-wide">Enterprise Document Command Center</span>
                            </div> */}
              {/* <div className="DocsHero_Badge">
                <Target className="DocsHero_BadgeIcon" />
                <span className="DocsHero_BadgeText">
                  Enterprise Document Command Center
                </span>
              </div> */}

              {/* <h1 className="text-7xl md:text-8xl lg:text-9xl text-white mb-8 tracking-tight leading-[0.95]" style={{ fontWeight: 300 }}>
                                Complete Control.<br />
                                <span className="bg-gradient-to-r from-cyan-400 via-cyan-300 to-cyan-500 bg-clip-text text-transparent" style={{ fontWeight: 400 }}>
                                    Zero Effort.
                                </span>
                            </h1> */}
              <h1 className="DocsHero_Title">
                Complete Control.
                <br />
                <span className="DocsHero_TitleGradient">Zero Effort.</span>
              </h1>

              <p className="DocsHero_Subtitle">
                Professional document management that works automatically.
                <br />
                Powerful search. Intelligent organization. Enterprise control.
              </p>
              <div className="md:block hidden w-32 h-[2px] bg-gradient-to-r from-transparent via-cyan-500 to-transparent mx-auto mt-16 mb-16"></div>

              {/* <div className="flex items-center justify-center gap-16 flex-wrap">
                                <div className="text-center">
                                    <p className="text-4xl bg-gradient-to-r from-cyan-400 to-cyan-500 bg-clip-text text-transparent mb-2" style={{ fontWeight: 300 }}>
                                        100%
                                    </p>
                                    <p className="text-sm text-gray-500 uppercase tracking-widest">Automatic</p>
                                </div>

                                <div className="text-center">
                                    <p className="text-4xl bg-gradient-to-r from-cyan-400 to-cyan-500 bg-clip-text text-transparent mb-2" style={{ fontWeight: 300 }}>
                                        &lt;2s
                                    </p>
                                    <p className="text-sm text-gray-500 uppercase tracking-widest">Search Speed</p>
                                </div>

                                <div className="text-center">
                                    <p className="text-4xl bg-gradient-to-r from-cyan-400 to-cyan-500 bg-clip-text text-transparent mb-2" style={{ fontWeight: 300 }}>
                                        ∞
                                    </p>
                                    <p className="text-sm text-gray-500 uppercase tracking-widest">Documents</p>
                                </div>
                            </div> */}
              <div className="DocsHero_Stats">
                <div className="DocsHero_Stat">
                  <p className="DocsHero_StatValue">100%</p>
                  <p className="DocsHero_StatLabel">Automatic</p>
                </div>

                <div className="DocsHero_Stat">
                  <p className="DocsHero_StatValue">&lt;2s</p>
                  <p className="DocsHero_StatLabel">Search Speed</p>
                </div>

                <div className="DocsHero_Stat">
                  <p className="DocsHero_StatValue">∞</p>
                  <p className="DocsHero_StatLabel">Documents</p>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-b from-transparent to-black pointer-events-none"></div> */}
        </div>
      </section>

      {/* Custom Apply */}
      {/* <section className="DocsHero">
                <div className="docs_Tabss">
                    <div className="DocsHero_Grid" />

                    <div className="DocsHero_Orb DocsHero_Orb--right" />
                    <div className="DocsHero_Orb DocsHero_Orb--left" />
                    <div className="DocsHero_RadialGlow" />

                    <div className="DocsHero_Container">
                        <div className="DocsHero_Header">
                            <div className="DocsHero_Badge">
                                <Target className="DocsHero_BadgeIcon" />
                                <span className="DocsHero_BadgeText">
                                    Enterprise Document Command Center
                                </span>
                            </div>

                            <h1 className="DocsHero_Title">
                                Complete Control.<br />
                                <span className="DocsHero_TitleGradient">Zero Effort.</span>
                            </h1>

                            <p className="DocsHero_Subtitle">
                                Professional document management that works automatically.<br />
                                Powerful search. Intelligent organization. Enterprise control.
                            </p>

                            <div className="DocsHero_Divider" />

                            <div className="DocsHero_Stats">
                                <div className="DocsHero_Stat">
                                    <p className="DocsHero_StatValue">100%</p>
                                    <p className="DocsHero_StatLabel">Automatic</p>
                                </div>

                                <div className="DocsHero_Stat">
                                    <p className="DocsHero_StatValue">&lt;2s</p>
                                    <p className="DocsHero_StatLabel">Search Speed</p>
                                </div>

                                <div className="DocsHero_Stat">
                                    <p className="DocsHero_StatValue">∞</p>
                                    <p className="DocsHero_StatLabel">Documents</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="DocsHero_FadeBottom" />
                </div>
            </section> */}

      <NavigateLikeFileSystem />
      <DocumentJourney />
      <ThreeCategoriesSection />
      {/* <ProfessionalPowerSection /> */}
      <CustomFooter />
    </div>
  );
}
